import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { AppSettings } from 'src/app/app-settings';
import { BondsServices } from 'src/app/services/bonds.service';
import { fixedPassFromLabel, isFixedPricePass } from 'src/app/utils/fixed-price-pass.util';
import { PassSelectDialogComponent } from '../../passes/pass-select-dialog/pass-select-dialog.component';
import { PassPurchaseComponent } from '../../passes/pass-purchase/pass-purchase.component';
import { passUnavailableMessage } from 'src/app/utils/pass-availability.util';

@Component({
  selector: 'app-owner-abonos',
  templateUrl: './owner-abonos.component.html',
  styleUrls: ['./owner-abonos.component.scss']
})
export class OwnerAbonosComponent implements OnChanges {

  @Input() companyId: number | null = null;
  @Input() ownerName: string = '';

  passes: any[] = [];
  loaded: boolean = false;
  searchText: string = '';
  urlImages: string = AppSettings.MEDIA_URI + '/events_images/';

  constructor(private bondsService: BondsServices, private router: Router, private dialog: MatDialog) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['companyId'] && this.companyId) {
      this.loadPasses();
    }
  }

  loadPasses() {
    this.loaded = false;
    this.bondsService.getPublicPassesByCompany(this.companyId!).subscribe({
      next: (res) => {
        this.passes = res?.passes || [];
        this.loaded = true;
      },
      error: () => {
        this.passes = [];
        this.loaded = true;
      }
    });
  }

  getDiscountLabel(pass: any): string {
    if (isFixedPricePass(pass)) {
      return fixedPassFromLabel(pass);
    }
    if (pass.discount_mode === 'percentage') {
      return `${Math.trunc(pass.discount_value)}% de descuento`;
    }
    return `${pass.discount_value}€ de descuento`;
  }

  getEventImages(pass: any): string[] {
    if (!pass.pass_items?.length) return [];
    return pass.pass_items
      .slice(0, 4)
      .map((item: any) => item.event?.image_url)
      .filter(Boolean)
      .map((img: string) => this.urlImages + img);
  }

  getEventCount(pass: any): number {
    return pass.pass_items?.length || pass.min_events || 0;
  }

  isFlexible(pass: any): boolean {
    return pass.min_events && pass.pass_items?.length && pass.min_events < pass.pass_items.length;
  }

  isMostSold(pass: any): boolean {
    return pass.purchase >= 10;
  }

  isComingSoon(pass: any): boolean {
    if (!pass.starts_at) return false;
    return new Date(pass.starts_at) > new Date();
  }

  getUnavailableMessage(pass: any): string | null {
    return passUnavailableMessage(pass);
  }

  get filteredPasses(): any[] {
    if (!this.searchText) return this.passes;
    const q = this.searchText.toLowerCase();
    return this.passes.filter(p => p.name?.toLowerCase().includes(q) || p.public_name?.toLowerCase().includes(q));
  }

  openPass(pass: any) {
    if (this.isComingSoon(pass) || this.getUnavailableMessage(pass)) return;
    const selectRef = this.dialog.open(PassSelectDialogComponent, {
      panelClass: ['info-dialog', 'pass-select-dialog-panel'],
      data: { passes: [pass] }
    });
    selectRef.afterClosed().subscribe((result: any) => {
      if (result?.pass) {
        this.dialog.open(PassPurchaseComponent, {
          panelClass: ['info-dialog', 'not-padding', 'pass-purchase-dialog-panel'],
          width: '860px',
          maxWidth: '95vw',
          data: { passId: result.pass.id, quantity: result.quantity || 1 }
        });
      }
    });
  }
}
